import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Fields } from 'redux-form'
import { I18n } from 'react-i18next'
import DateRangePicker from '../../../../components/Calendar/DateRangePicker'
import { changeRangeCalendar } from '../../actions'
import {
    getModule,
    getDateRangeEndOpened,
    getDateRangeStartOpened,
    getLanguage
} from '../../selectors'

// binding for redux-form
const VisualComponent = ({
    names,
    startOpened,
    endOpened,
    onOpenChange,
    disabled,
    editable,
    module,
    language,
    path,
    ...props
}) => {
    const startInput = _.get(props, names[0]).input
    const endInput = _.get(props, names[1]).input

    return (
        <I18n ns={[module.model, 'platform']}>
            {t => (
                <DateRangePicker
                    path={path}
                    startDate={startInput.value}
                    endDate={endInput.value}
                    startOpened={startOpened}
                    endOpened={endOpened}
                    onChange={(index, date) => {
                        if (date) {
                            index === 0
                                ? startInput.onChange(date)
                                : endInput.onChange(date)
                        }
                    }}
                    onOpenChange={onOpenChange}
                    language={language}
                    startPlaceholder={t('pickDate')}
                    endPlaceholder={t('pickDate')}
                    disabled={!editable || disabled}
                    t={t}
                />
            )}
        </I18n>
    )
}

const DateRangePickerComponent = ({
    field,
    startOpened,
    endOpened,
    changeRangeCalendar,
    module,
    language,
    objectMode
}) => {
    const fieldName = field.path

    return (
        <Fields
            names={[`${fieldName}[0]`, `${fieldName}[1]`]}
            path={field.tKey || field.path}
            component={VisualComponent}
            startOpened={startOpened}
            endOpened={endOpened}
            language={language}
            onOpenChange={(index, opened) =>
                changeRangeCalendar(field.id, index, opened)
            }
            disabled={field.disabled || !field.writable}
            editable={!field.editable ? objectMode === 'newObject' : field.editable  }
            module={module}
        />
    )
}

const mapStateToProps = (state, { field }) => ({
    startOpened: getDateRangeStartOpened(state, field.id),
    endOpened: getDateRangeEndOpened(state, field.id),
    language: getLanguage(state),
    module: getModule(state)
})

const mapDispatchToProps = {
    changeRangeCalendar: changeRangeCalendar
}

export default connect(mapStateToProps, mapDispatchToProps)(
    DateRangePickerComponent
)
